import { useEffect } from "react";

function metaByName(name, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function metaByProp(prop, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path, jsonLd, type = "website" }) {
  useEffect(() => {
    if (title) document.title = title;
    metaByName("description", description);
    metaByProp("og:title", title);
    metaByProp("og:description", description);
    metaByProp("og:type", type);
    const url = window.location.origin + (path || window.location.pathname);
    metaByProp("og:url", url);
    setLink("canonical", url);

    let script = document.getElementById("route-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "route-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, jsonLd, type]);

  return null;
}
